import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        window.history.replaceState({}, "", "/");
        await refresh();
        navigate("/", { replace: true });
      } catch {
        setError("No pudimos autenticarte con Google. Intenta de nuevo.");
        setTimeout(() => navigate("/", { replace: true }), 2500);
      }
    })();
  }, [location, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-void">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-neon-cyan mx-auto mb-4" />
        <p className="font-mono text-sm text-muted-foreground uppercase tracking-widest">
          {error || "Verificando sesión..."}
        </p>
      </div>
    </div>
  );
}
